import { render, staticRenderFns } from "./MemberQuestions.vue?vue&type=template&id=bf77bfec&scoped=true&lang=pug&"
import script from "./MemberQuestions.vue?vue&type=script&lang=js&"
export * from "./MemberQuestions.vue?vue&type=script&lang=js&"
import style0 from "./MemberQuestions.vue?vue&type=style&index=0&id=bf77bfec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf77bfec",
  null
  
)

export default component.exports